import React, { useEffect, useState, useCallback } from "react";
import { Modal, Typography, Form, message, Select } from "antd";
import styled from "styled-components";
import VeritasSpinner from '../VeritasSpinner'
import { API_TYPES } from "../../constants";

export const Label = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  &:nth-child(1) {
    margin-left: auto;
  }
`

const UpdateCaseStatusModal = ({
  apiClasses,
  apiType,
  caseId,
  visible,
  setVisible,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [availableCaseStatuses, setAvailableCaseStatuses] = useState([])

  const getAvailableCaseStatuses = useCallback(async () => {
    if (!apiClasses?.LookUpAPI && !apiClasses?.APIHelper) {
      message.error("LookUpAPI/APIHelper is not available");
      return;
    }
    
    try {
      setLoading(true)
      const { data } = apiType === API_TYPES.PHYSICIAN 
        ? await apiClasses.APIHelper.fetchLookUp("case-status") 
        : await apiClasses.LookUpAPI.lookUp("case-status")
      
      if (apiType === API_TYPES.PHYSICIAN) {
        return setAvailableCaseStatuses(data.payload.filter(status => status.name.toLowerCase() === "pending prescription"))
      }
      setAvailableCaseStatuses(data.payload)
    } catch (e) {
      console.error("Error fetching available case statuses:", e)
      message.error("Unable to get available statuses");
    } finally {
      setLoading(false)
    }
  }, [apiClasses])

  useEffect(() => {
    if (visible) {
        getAvailableCaseStatuses()
    }
  }, [visible, getAvailableCaseStatuses])

  const updateCaseStatus = async (status) => {
    if (!apiClasses?.CasesApi && !apiClasses?.PhysicianAPI) {
      message.error("CasesAPI/PhysicianAPI is not available");
      return;
    }
    
    try {
      setLoading(true)
      apiType === API_TYPES.PHYSICIAN 
        ? await apiClasses.PhysicianAPI.updateCaseStatus(caseId, { status: status.toLowerCase() }) 
        : await apiClasses.CasesApi.updateCaseStatusV2(caseId, { status: status.toLowerCase() })
      onSuccess()
    } catch (e) {
      const errorMessage = e.response?.data?.message || e.message
      console.error("Error updating case status:", e)
      message.error(`Unable to update case status - ${errorMessage}`);
    } finally {
      setLoading(false)
      setVisible(false)
    }
  };

  return (
    <Modal
      title="Update Status"
      open={visible}
      closable={!loading}
      onCancel={() => setVisible(false)}
      destroyOnClose
      zIndex={1010}
      footer={null}
    >
      <VeritasSpinner spinning={loading}>
        <Form>
          <Label>
            <Typography.Text>Select a new status</Typography.Text>
          </Label>
          <Form.Item>
            <Select
              id="update-case-status-select"
              showSearch
              placeholder="Select a new status"
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={availableCaseStatuses
                .filter(status => status.displayName)
                .map(status => ({ 
                  label: status.displayName, 
                  value: status.displayName 
                }))}
              onSelect={updateCaseStatus}
            />
          </Form.Item>
        </Form>
      </VeritasSpinner>
    </Modal>
  )
}

export default UpdateCaseStatusModal
